export const RocketSVG = () => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="#FFD700">
    <path d="M32 2C14.4 2 0 16.4 0 34s14.4 32 32 32 32-14.4 32-32S49.6 2 32 2zm0 56c-7.8 0-14.8-4-18.8-10.2l14.2-7.1 1.4 1.4c1.8 1.8 4.2 2.8 6.6 2.8 2.4 0 4.8-1 6.6-2.8l1.4-1.4 14.2 7.1c-4 6.2-11 10.2-18.8 10.2zm-8.2-12.2L10.8 34l11.4-5.7 5.7 11.4-5.7 5.7zM32 22c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10z"/>
  </svg>
);